import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DetailsView from '../DetailsView';
import OrganizationInputs from '../../../components/admin/forms/organizations/OrganizationInputs';
import OrganizationShow from '../../../components/admin/forms/organizations/OrganizationShow';
import { MODELS } from '../../../constants/admin/settings';
import { create, update, fetchMember } from '../../../actions/admin/models/organizations';
import Tabs from '../AdminTabs';

class Details extends Component {
    render() {
        return (
            <Tabs
                disable={!this.props.match.params.context}
                labels={['Details']}
                content={[
                    <DetailsView
                        model={MODELS.ORGANIZATION}
                        withShowMode={!!this.props.match.params.context}
                        fetchModel={this.props.fetchMember}
                        modelId={this.props.match.params.context}
                        editView={OrganizationInputs}
                        showView={OrganizationShow}
                        updateAction={this.props.update}
                        createAction={this.props.create}
                    />
                ]}
            />
        );
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => bindActionCreators({ create, update, fetchMember }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Details);



// WEBPACK FOOTER //
// ./src/containers/admin/organizations/Details.js